import React from "react";
import { CurrencyDollar, Lightning, Plugs, Certificate } from "@phosphor-icons/react";

const proofs = [
  {
    icon: Lightning,
    title: "Рост пропускной способности",
    value: "2.5×",
    body: "Инференс LLM на существующем парке без апгрейда GPU.",
    testid: "proof-throughput",
  },
  {
    icon: Certificate,
    title: "Запатентованная технология",
    value: "DeepTech Research",
    body: "На технологии InBoost поданы международные патенты.",
    testid: "proof-patents",
  },
  {
    icon: Plugs,
    title: "Интеграция MCP",
    value: "Native",
    body: "Управление инфраструктурой автономными ИИ-агентами по Model Context Protocol.",
    testid: "proof-mcp",
  },
];

export const SocialProof = () => {
  return (
    <section data-testid="social-proof-section" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-12">
          <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
            / 05 — Доказательства
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-3xl">
            Числа для вашего{" "}
            <span className="text-brand-cyan">CFO</span>.
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          {/* Hero case card */}
          <div
            data-testid="case-13m"
            className="lg:col-span-7 relative rounded-2xl glass-strong p-10 sm:p-12 overflow-hidden"
          >
            <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-brand/20 blur-[120px]" />
            <div className="absolute -bottom-24 -right-24 w-[320px] h-[320px] rounded-full bg-brand-cyan/15 blur-[120px]" />

            <div className="relative">
              <div className="flex items-center gap-2 mb-6">
                <CurrencyDollar size={18} weight="fill" className="text-brand-cyan" />
                <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan">
                  Case study · Production cluster
                </div>
              </div>

              <div className="font-heading font-black tracking-tighter leading-none">
                <span className="text-5xl sm:text-7xl lg:text-8xl mono bg-gradient-to-r from-brand to-brand-cyan bg-clip-text text-transparent">
                  $13.3M
                </span>
                <span className="text-2xl sm:text-3xl text-ink-text ml-3">/ год</span>
              </div>

              <div className="mt-5 text-muted text-base sm:text-lg max-w-xl leading-relaxed">
                Экономия для кластера на{" "}
                <span className="mono text-ink-text">1024 GPU</span> за счёт повышения
                утилизации с 38% до 84% и устранения фрагментации памяти HBM.
              </div>

              <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
                {[
                  ["1024", "GPU"],
                  ["84%", "UTIL"],
                  ["6 мес", "PAYBACK"],
                ].map(([v, l]) => (
                  <div key={l} className="rounded-xl bg-ink-elevated border border-ink-text/5 p-3">
                    <div className="mono text-xl font-bold text-brand-cyan">{v}</div>
                    <div className="mono text-[10px] uppercase tracking-widest text-muted mt-1">
                      {l}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right column proofs */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            {proofs.map((p) => (
              <div
                key={p.testid}
                data-testid={p.testid}
                className="glass rounded-2xl p-7 relative overflow-hidden flex-1"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-lg bg-brand-cyan/10 border border-brand-cyan/30 flex items-center justify-center">
                    <p.icon size={20} weight="duotone" className="text-brand-cyan" />
                  </div>
                  <div className="font-heading font-semibold">{p.title}</div>
                </div>
                <div className="font-heading font-black mono text-4xl text-brand-cyan text-glow-cyan">
                  {p.value}
                </div>
                <p className="mt-3 text-sm text-muted leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Logos / partners marquee */}
        <div className="mt-16 overflow-hidden">
          <div className="mono text-[10px] uppercase tracking-[0.22em] text-muted mb-5 text-center">
            Совместимость и партнёрства
          </div>
          <div className="relative">
            <div className="marquee whitespace-nowrap flex gap-12 mono text-sm text-muted/80">
              {[
                "NVIDIA DCGM",
                "Kubernetes",
                "Kueue",
                "MIG",
                "NVLink",
                "InfiniBand",
                "Model Context Protocol",
                "Сколково",
                "NVIDIA Inception",
                "Prometheus",
                "Grafana",
                "Triton Inference",
              ]
                .concat([
                  "NVIDIA DCGM",
                  "Kubernetes",
                  "Kueue",
                  "MIG",
                  "NVLink",
                  "InfiniBand",
                  "Model Context Protocol",
                  "Сколково",
                  "NVIDIA Inception",
                  "Prometheus",
                  "Grafana",
                  "Triton Inference",
                ])
                .map((t, i) => (
                  <span key={i} className="flex items-center gap-3">
                    <span className="w-1 h-1 rounded-full bg-brand-cyan" />
                    {t}
                  </span>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
